import NaturalPersonFormFields from './NaturalPersonFormFields';

export default NaturalPersonFormFields;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/upsert-watch-list-entry-form/natural-person-form-fields/index.js